import type { UseCase } from '@/core/shared'
import type { ChargePointRepository } from '../domain'

export const getAllChargePoint: UseCase<ChargePointRepository, 'getAllChargePoint'> = (repository) => {
  return async (groupUid, params) => {
    return await repository.getAllChargePoint(groupUid, params)
  }
}
